// tools
import { initGoogleAnalytics } from '@tools/google-analytics'

export default defineNuxtPlugin(() => {
  onNuxtReady(() => initGoogleAnalytics())
})
